import Vue from "vue";
import router from "@/router";
import store from "@/store/store";
import { Auth0Plugin, getInstance } from "@/auth";
import { AuthService } from "@/services/auth.service";

const opts = {
  domain: process.env.AUTH0_DOMAIN,
  clientId: process.env.AUTH0_CLIENT_ID,
  audience: process.env.AUTH0_AUDIENCE,
  onRedirectCallback: async appState => {
    // const Auth0Plugin = getInstance();
    // const token = await Auth0Plugin.getTokenSilently();

    // try {
    //   const response = await AuthService.loginAuth0({ token });
    //   console.log(response);
    //   store.dispatch("Auth/setToken", data.token);
    //   router.push({ name: "profile" });
    // } catch (err) {}
  }
};

Vue.use(Auth0Plugin, opts);



// WEBPACK FOOTER //
// ./src/plugins/auth0.js